import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import firebase from 'firebase/app';
import 'firebase/auth';

import global from '../../stores/GlobalStore';

import './styles/Login.scss';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      signUp: false,
      email: '',
      password: '',
      confirmPassword: '',
      error: '',
      loggedIn: false,
      token: '',
    };
  }

  onFocus = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };

  onChange = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  LaunchSignUp = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    this.setState({
      signUp: true,
      error: '',
    });
  };

  hideSignUp = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    this.setState({
      signUp: false,
      error: '',
    });
  };

  handleRegister = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    global()
      .getUserStore()
      .userRegister(
        this.state.username,
        this.state.email,
        this.state.password,
        this.state.confirmPassword,
        (response = {}) => {
          if (response.status === 200) {
            this.saveUserToLocalStorage(response.payload);
          } else {
            this.handleError(response);
          }
        }
      );
  };

  handleSignIn = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();

    global()
      .getUserStore()
      .userLogin(this.state.email, this.state.password, (response = {}) => {
        if (response.status === 200) {
          this.saveUserToLocalStorage(response.payload);
        } else {
          this.handleError(response);
        }
      });
  };

  socialLogin = network => {
    let provider;

    switch (network) {
      case 'TWITTER': {
        provider = new firebase.auth.TwitterAuthProvider();
        break;
      }
      case 'GOOGLE':
      default: {
        provider = new firebase.auth.GoogleAuthProvider();
        provider.addScope('https://www.googleapis.com/auth/plus.login');
      }
    }

    firebase
      .auth()
      .signInWithPopup(provider)
      .then(authData => {
        if (authData && authData.user && authData.user.email) {
          let firstName, lastName;
          if (authData.user.displayName && authData.user.displayName.indexOf(' ') > -1) {
            const names = authData.user.displayName && authData.user.displayName.split(' ');
            firstName = names[0];
            if (names.length > 1) {
              lastName = names[1];
            }
          } else {
            firstName = authData.user.displayName;
          }

          global()
            .getUserStore()
            .userSocialLogin(
              {
                email: authData.user.email,
                avatarUrl: authData.user.photoURL,
                firstName: firstName,
                lastName: lastName,
              },
              (response = {}) => {
                if (response.status === 200) {
                  this.saveUserToLocalStorage(response.payload);
                } else {
                  this.handleError(response);
                }
              }
            );
        }
      })
      .catch(error => {
        let email = error.email;

        if (email) {
          global()
            .getUserStore()
            .userSocialLogin({ email }, (response = {}) => {
              if (response.status === 200) {
                this.saveUserToLocalStorage(response.payload);
              } else {
                this.handleError(response);
              }
            });
        }
      });
  };

  saveUserToLocalStorage(user) {
    localStorage.setItem('access_token', user.access_token);
    localStorage.setItem('expires_at', moment().add(30, 'd'));
    localStorage.setItem('email', user.email);
    localStorage.setItem('first_name', user.first_name || '');
    localStorage.setItem('user_id', user.user_id);
    localStorage.setItem('avatar_url', user.avatar_url);
    localStorage.setItem('username', user.username);
    localStorage.setItem('categories', user.categories);
    localStorage.setItem('emailConfirmed', user.emailConfirmed);

    global()
      .getUserStore()
      .getUserStreamToken(user.user_id, token => {
        localStorage.setItem('stream_token', token);
      });

    this.setState({ error: '', loggedIn: true, token: user.access_token });
    this.props.setLoggedInUser(user);
  }

  handleError(response) {
    this.setState({ error: response.error, loggedIn: false });
  }

  redirectToHome() {
    setTimeout(() => {
      window.location.href = '/';
    }, 500);
  }

  renderSocialLogin = () => {
    return (
      <div className='social-login'>
        <div className='social-login-btn btn-google' onClick={this.socialLogin.bind(this, 'GOOGLE')}>
          <i className='fab fa-google' />
        </div>
        <div className='social-login-btn btn-twitter' onClick={this.socialLogin.bind(this, 'TWITTER')}>
          <i className='fab fa-twitter' />
        </div>
      </div>
    );
  };

  render() {
    const SignUp = (
      <div className='flex-lay' onClick={this.onFocus}>
        <div className='login-modal'>
          <form action='' method='post'>
            <div className='login-container'>
              <div id='input'>
                <input type='text' name='username' placeholder='Username' onChange={this.onChange} />
                <input type='text' name='email' placeholder='Email address' onChange={this.onChange} />
                <input type='password' name='password' placeholder='Password' onChange={this.onChange} />
                <input type='password' name='confirmPassword' placeholder='Password again' onChange={this.onChange} />
              </div>
              <div id='option'>
                Password should be more than 6 characters, must contain one letter, number and special character
              </div>
              {this.state.error && Object.keys(this.state.error).length ? (
                <div className='login-error'>{this.state.error}</div>
              ) : null}
              <input type='button' value='CREATE ACCOUNT' id='LoginBtn' onClick={this.handleRegister} />
              <div id='option'>
                Already have an account?{' '}
                <div className='toggle-button raf-button' onClick={this.hideSignUp}>
                  {' '}
                  Sign in
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
    const Login = (
      <div className='flex-lay' onClick={this.onFocus}>
        <div className='login-modal'>
          <form action='' method='post'>
            <div className='login-container'>
              <div id='input'>
                <input name='email' type='text' placeholder='Email' onChange={this.onChange} />
                <input name='password' type='password' placeholder='Password' onChange={this.onChange} />
              </div>
              <input type='button' value='SIGN IN' id='LoginBtn' className='raf-button' onClick={this.handleSignIn} />
              {this.state.error && Object.keys(this.state.error).length ? (
                <div className='login-error'>{this.state.error}</div>
              ) : null}
              <div className='social-login'>{this.renderSocialLogin()}</div>
              <div id='option'>
                Don't have an account?
                <div className='toggle-button raf-button' onClick={this.LaunchSignUp}>
                  {' '}
                  Sign Up Now{' '}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
    return <div>{this.state.loggedIn ? this.redirectToHome() : this.state.signUp ? SignUp : Login}</div>;
  }
}

Login.propTypes = {
  setLoggedInUser: PropTypes.func.isRequired,
};

export default Login;
